<template>
  <BCol cols="12" v-if="resourceDetails">
    <BRow class="custom-inner-table-bg-color rounded-sm py-1">
      <BCol cols="3" class="px-2 mx-auto">
        {{ resourceDetails.title }}
      </BCol>
      <BCol cols="4" class="px-2 mx-auto">
        <BImg
          width="70px"
          rounded
          height="auto"
          fluid
          :src="`${baseUrl}/${resourceDetails.imageUrl}`"
        ></BImg>
      </BCol>
      <BCol cols="4" class="mx-auto">
        <BButton
          variant="transparent"
          @click="renderUpdateResourceDetailSection(resourceDetails)"
        >
          <FeatherIcon icon="EditIcon" size="23" class="text-info" />
        </BButton>
        <BButton
          variant="transparent"
          :to="`/apps/resources/${resourceDetails.id}`"
        >
          <FeatherIcon icon="ExternalLinkIcon" size="23" class="text-primary" />
        </BButton>
        <BButton
          variant="transparent"
          @click="renderDeleteDialogConfirmation(resourceDetails)"
        >
          <FeatherIcon icon="Trash2Icon" size="23" class="text-danger" />
        </BButton>
      </BCol>
    </BRow>
    <UpdateResourceDialog
      :dialogId="resourceDetails.id"
      :resourceDetails="tempSelectedUpdateResource"
      :resourceId="resourceId"
      :defaultImage="tempSelectedResourceImage"
      @refetch="refetch"
    >
    </UpdateResourceDialog>
    <RemoveResourceConfirmationDialog
      :dialogId="resourceDetails.id"
      :resourceDetails="tempSelectedResource"
      @refetch="refetch"
    ></RemoveResourceConfirmationDialog>
  </BCol>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    resourceDetails: {
      type: Object,
    },
    resourceId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      tempSelectedResource: null,
      tempSelectedResourceImage: null,
      tempSelectedUpdateResource: {
        resourceId: null,
        resourceDetailId: null,
        title: null,
        imageFile: null,
      },
    };
  },
  methods: {
    refetch() {
      this.$emit("refetch");
    },
    renderUpdateResourceDetailSection(resourceDetail) {
      this.tempSelectedResourceImage = resourceDetail.imageUrl;
      this.tempSelectedUpdateResource = {
        resourceId: this.resourceId,
        resourceDetailId: resourceDetail.id,
        title: resourceDetail.title,
        imageFile: null,
      };
      this.tempSelectedUpdateResource.resourceId = this.resourceId;
      this.$bvModal.show(`update-resource-dialog-${resourceDetail.id}`);
    },
    renderDeleteDialogConfirmation(resource) {
      this.tempSelectedResource = resource;
      this.$bvModal.show(`remove-single-resource-from-language-${resource.id}`);
    },
  },

  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    RemoveResourceConfirmationDialog,
    UpdateResourceDialog,
    BButton,
    BRow,
    BCol,
    BImg,
  },
};
import UpdateResourceDialog from "@/views/components/Resources/UpdateResourceDialog.vue";
import RemoveResourceConfirmationDialog from "@/views/components/Resources/RemoveResourceConfirmationDialog.vue";
import { BRow, BCol, BButton, BImg } from "bootstrap-vue";
</script>
